import { EventSession, Order } from "@types";
import apiClient from "./api-client";

export type Orders = Order[];

export type EventConsistTypes = 'TICKET' | 'SEASON_TICKET' | 'FLEX_PASS';

/** Сезонные и наборные абонементы в одном запросе. */
export const SEASON_PASS_EVENT_CONSIST_TYPES: EventConsistTypes[] = [
    'SEASON_TICKET',
    'FLEX_PASS',
];

export interface EventSessionsPageResponse {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    content: EventSession[];
}

class EventSessionApi {

    async getEventSessionById(eventSessionId: number) {
        const { data } = await apiClient.get(
            `/api/event-sessions/${eventSessionId}`
        ) as { data: EventSession };
        return data;
    }

    async getEventSessions(eventSessionId: number, ticketUuid?: string | null) {
        const { data } = await apiClient.get(`/api/event-sessions/${eventSessionId}/contents`, {
            params: ticketUuid ? { ticketUuid } : undefined,
        }) as { data: EventSession[] };
        return data;
    }

    async getEventSessionsPage(
        eventConsistTypes: EventConsistTypes | EventConsistTypes[],
        pageNumber: number,
        pageSize: number
    ): Promise<EventSessionsPageResponse> {
        const types = Array.isArray(eventConsistTypes)
            ? eventConsistTypes
            : [eventConsistTypes];
        const searchParams = new URLSearchParams();
        types.forEach((type) => searchParams.append('eventConsistTypes', type));
        searchParams.append('pageNumber', String(pageNumber));
        searchParams.append('pageSize', String(pageSize));

        const { data } = await apiClient.get(
            `/api/event-sessions?${searchParams.toString()}`
        ) as { data: EventSessionsPageResponse };
        return data;
    }
}

const eventSessionsApi = new EventSessionApi();

export default eventSessionsApi;
